"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sorter = void 0;
const getByPath = (obj, path) => path.split(".").reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
/**
 * @param sortBy path to sorted by field (default - 'id')
 */
const sorter = (sortBy = "id") => (a, b) => {
    const valA = getByPath(a, sortBy);
    const valB = getByPath(b, sortBy);
    if (valA === valB)
        return 0;
    if (valA === null)
        return 1;
    if (valB === null)
        return -1;
    return valA > valB ? 1 : -1;
};
exports.sorter = sorter;
//# sourceMappingURL=sorter.js.map